import React from 'react';
import Button from 'Components/Button';
import ErrorIcon from 'Static/icons/error-icon.svg';
import styles from './PaymentError.scss';
import { ROUTES } from 'Settings/route-strings';

const PaymentError = () => {
  return (
    <div className="PaymentError">
      <ErrorIcon className="PaymentError__icon" />
      <p className="PaymentError__message">
        Your payment was processed, but there was an issue logging you back in.
        Please try signing in again.
      </p>
      <Button
        buttonType="primary"
        clickHandler={() => {
          window.location.pathname = ROUTES.SIGN_IN;
        }}
        label="Sign In"
      />
      <p style={{ marginTop: '3em' }}>
        If you cannot sign in, please contact us at{' '}
        <a href="mailto:support.schools@tinybop.com" className="u-text-link">
          support.schools@tinybop.com
        </a>
        .
      </p>
    </div>
  );
};

export default PaymentError;
